export default {
  title: 'Info',
  sections: {
    work_schedule: 'Åbningstider: Online bestilling',
    delivery_schedule: 'Leveringstider',
    delivery_costs: 'Leveringsgebyr',
    website: 'Hjemmeside',
  },
  labels: {
    delivery_fees: 'Min. beløb - {{threshold}}, gebyr - {{fee}}',
  },
};
